import React from 'react';
type NoSSRProps = React.PropsWithChildren<{
  fallback?: React.ReactNode;
}>;

export function NoSSR({ children, fallback }: NoSSRProps) {
  const [render, setRender] = React.useState(false);
  React.useEffect(() => {
    setRender(true);
  }, []);

  if (!render) {
    return <>{fallback}</>;
  }

  return <>{children}</>;
}
